module.exports = __webpack_public_path__ + "static/media/I_obey_what_the_hypno_virus_say.90e52730.mp3";